module.exports = __webpack_public_path__ + "static/media/better-job-fit-alicia.ace0dcae.jpg";